import { useCommonServices } from '../../../lib/hooks/services'
import { DiscountData } from '../../../lib/services/facade'
import { Cookie } from '../../../lib/utils/cookies'
import { LogErrorMetrics, logError } from '../../../lib/tracking/felog'

const atob = (base64: string) => {
  return Buffer.from(base64, 'base64').toString('binary')
}

type AffiliateType = 'GBUpgrade' | string

export interface AffiliateData {
  affName: string
  discountValue: number
  affType?: AffiliateType
}

const getAffiliateDataFromFacade = (discountData?: DiscountData): AffiliateData | undefined => {
  const { name: discountName, value: discountValue, offerType: discountType } = discountData || {}

  try {
    const parsedDiscountValue = Number(discountValue)

    if (!discountName || isNaN(parsedDiscountValue)) {
      return undefined
    }

    return {
      affName: atob(discountName),
      discountValue: parsedDiscountValue,
      affType: discountType ? atob(discountType) : undefined,
    }
  } catch (_err) {
    logError('Error parsing Discount information from facade', LogErrorMetrics.Discount, {
      rawDiscountCookieData: {
        [Cookie.GrammarlyDiscountName]: discountName,
        [Cookie.GrammarlyDiscountValue]: discountValue,
        [Cookie.GrammarlyDiscountType]: discountType,
      },
    })
  }
}

const getConsumerAffiliateData = (discountData?: DiscountData): AffiliateData | undefined => {
  const affiliateData = getAffiliateDataFromFacade(discountData)
  return affiliateData?.affType !== 'GBUpgrade' && affiliateData?.discountValue ? affiliateData : undefined
}

const isValidDiscount = (discount: number): boolean => discount < 100 && discount > 0

export const useDiscount = (): { discountValue: number | undefined } => {
  const { discount: discountData } = useCommonServices().facadeService.get()

  const affiliateData = getConsumerAffiliateData(discountData)

  let discountValue
  if (affiliateData && isValidDiscount(affiliateData.discountValue)) {
    discountValue = affiliateData.discountValue
  }

  return { discountValue }
}
